<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.all()"
      :model="model"
      :errors="errors"
      layout="nolabel"
    />
    <label class="text-label text-right">
      <a :href="forgotUrl">
        {{ $t("Forgot a Password?") }}
      </a>
    </label>
    <div class="form-group">
      <input type="submit" :value="$t('Log In')" class="reg-btn" />
    </div>
  </form>
</template>

<script>
import { FormMixin } from "stylemix-base";
import LanguageMixin from "../mixins/LanguageMixin";

export default {
  name: "Login",

  mixins: [FormMixin, LanguageMixin],

  data() {
    return {
      model: window.LOGIN.data,
      forgotUrl: FORGOT_URL,
    };
  },

  created() {
    this.setFields(window.LOGIN.fields);

    let keys = ["email", "password"];
    keys.forEach((key) => {
      let field = this.fields.get(key);
      field.placeholder = this.$t(field.label);
    });
  },

  methods: {
    submit() {
      this.errors.clear();
      this.$http
        .post("login", this.model, { baseURL: window.HOME_URL })
        .then((response) => {
          let accountUrl = "/account";

          if (this.lang) {
            accountUrl = `/${this.language}${accountUrl}`;
          }

          window.location.href = accountUrl;
        })
        .catch((rejection) => {
          const response = rejection.response;
          if (!response) {
            return;
          }

          if (response.status === 422) {
            this.setValidationErrors(response.data.errors);
          }

          if (response.status === 403) {
            this.setValidationErrors({
              email: [response.data.message],
            });
          }
        });
    },
  },
};
</script>
